"use client";

import Section from "@/components/static/Section";
import Headline from "@/components/static/Headline";
import Text from "@/components/static/Text";
import Image from "next/image";
import { useState } from "react";
import { useRef } from "react";
import parse from "html-react-parser";
import { AnimatePresence, motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { SectionPadding, HeadlineProps, ImageProps, ButtonProps } from "@/lib/types";

//@ts-ignore
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

type Content = {
    headline: HeadlineProps;
    intro: string;
    image: ImageProps;
    settings: {
        padding: SectionPadding;
        backgroundColor: string;
    };
    buttons: ButtonProps[];
    items: SlideProps[];
};

type SlideProps = {
    headline: string;
    text: string;
    image: ImageProps;
};

export default function Gallery_18({ content }: { content: Content }) {
    const splideRef = useRef<any>(null);
    const [current, setCurrent] = useState(0);

    const handleSlideChange = (splide: any) => {
        setCurrent(splide.index);
    };

    return (
        <Section dataComponent='Gallery_18' settings={content?.settings}>
            <div className='container'>
                <div className='flex justify-center flex-col items-center mb-20'>
                    <div className='max-w-lg text-center'>
                        <Headline
                            tag={content.headline.tag}
                            align='center'
                            topline={content.headline.topline}
                        >
                            {content.headline.title}
                        </Headline>
                        {content.intro && (
                            <Text className='prose text-textSecondary'>{parse(content.intro)}</Text>
                        )}
                    </div>
                </div>

                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
                    {content.items?.map((item, i: number) => (
                        <div className='bg-bg-tale rounded-2xl' key={i}>
                            <div
                                className={cn(
                                    "flex flex-col h-full p-6 gap-8 items-center md:p-10 bg-on-primary",
                                    content.settings.backgroundColor == "brand"
                                        ? "bg-brand"
                                        : "bg-on-primary"
                                )}
                            >
                                {item.image && (
                                    <Image
                                        src={item.image.url}
                                        alt={item.image.alt}
                                        className='size-28'
                                        width={item.image.width}
                                        height={item.image.height}
                                    />
                                )}
                                <div className='flex flex-col grow  col-span-full gap-4 lg:col-span-1'>
                                    {item.headline && (
                                        <h3 className='text-h5 text-center font-medium text-white'>
                                            {item.headline}
                                        </h3>
                                    )}
                                    {item.text && (
                                        <Text className='text-white text-center'>{item.text}</Text>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Section>
    );
}
